import React from 'react';

// First run: a device was just connected and its history is still landing.
// Said once, plainly, with motion so it reads as in-progress rather than empty.
// The hook behind the feed polls while this is showing.

const ImportingNotice = ({ quiet }) => (
  <div
    className="flex items-start gap-4 rounded-2xl border border-line bg-raised p-5"
    role="status"
    aria-live="polite"
  >
    <span
      className="mt-1 h-5 w-5 shrink-0 animate-spin rounded-full border-2 border-fg-3 border-t-transparent"
      aria-hidden
    />
    <div>
      <h3 className="text-lg font-medium text-fg">Importing your history</h3>
      <p className="mt-1 text-sm text-fg-2">
        {quiet?.text || 'Up to a year of readings is on its way. Your first observations appear once it lands.'}
      </p>
    </div>
  </div>
);

export default ImportingNotice;
